import Ajax from "shared/ajax";

import Model from "backdraft-app/src/model";

export default class Recording extends Model {
  initialize(options = {}) {
    this.url = options.url || "";
  }

  defaults() {
    return ({
      recordId: "",
      recordTitle: "",
      recordingUrl: "",
      reportedRecordingDuration: 0,
      trueRecordingDuration: 0,
      alertMessage: "",
      play: false,
      playText: "Play",
      audioProgress: 0,
      downloadUrl: "",
      enabled: true
    });
  }

  activate() {
    if (this.get('recordingUrl')) {
      this.trigger('activate', this);
    } else {
      this.trigger('fetchRequest', this);
      this.set('playText', 'Loading');
      this.requestUrl();
    }
  }

  deactivate() {
    this.set({
      play: false,
      playText: "Play",
      audioProgress: 0
    });
  }

  play(trueRecordingDuration) {
    this.set({
      play: true,
      playText: "Pause"

    }, { silent: true });
    this.trigger('change change:play');
  }

  pause() {
    this.set({
      play: false,
      playText: "Play"
    });
  }

  togglePlay() {
    const play = !this.get('play');
    const playText = play ? "Pause" : "Play";
    this.set({
      play,
      playText
    });
  }

  handleClick() {
    if (this.get('recordingUrl')) {
      this.togglePlay();
    }
    this.activate();
  }

  setTrueRecordingDuration(duration) {
    this.set({
      trueRecordingDuration: duration
    });
  }

  setAlert(message) {
    this.set({
      alertMessage: message,
      play: false,
      playText: "Play"
    }, { silent: true });
    this.trigger('change change:alertMessage');
  }

  shiftBrowserAudioProgress(audioProgress, silent) {
    this.set({
      audioProgress
    }, { silent });
  }

  shiftRecordingProgress(audioProgress) {
    this.shiftBrowserAudioProgress(audioProgress, true);
    this.trigger('shiftRecordingProgress', this);
  }

  loading() {
    return this.get('playText') === "Loading";
  }

  audioTime() {
    return this._formattedAudioTime(this._effectiveSeconds());
  }

  totalAudioTime() {
    return this._formattedAudioTime(this._effectiveRecordingDuration());
  }

  requestUrl() {
    this.fetch({
      success(model, response) {
        model._handleSuccess(response);
      },
      error(model, response) {
        model._handleError(response);
      }
    });
  }

  _handleSuccess({ recordingUrl }) {
    this.set({
      recordingUrl,
      alertMessage: ""
    }, { silent: true });
    this.trigger('fetchSuccess', this);
  }

  _handleError(response) {
    this.setAlert(this._errorMessage(response));
  }

  _formattedAudioTime(seconds) {
    const date = new Date(null);
    date.setSeconds(seconds);

    return date.toISOString().substr(11, 8);
  }

  _effectiveRecordingDuration() {
    let effectiveRecordingDuration;

    if (this.get('reportedRecordingDuration')) {
      effectiveRecordingDuration = this.get('reportedRecordingDuration');
    } else if (this.get('trueRecordingDuration')) {
      effectiveRecordingDuration = this.get('trueRecordingDuration');
    } else {
      effectiveRecordingDuration = 0;
    }

    return effectiveRecordingDuration;
  }

  _effectiveSeconds() {
    const effectiveSeconds = this.get('audioProgress') * this._effectiveRecordingDuration();

    return effectiveSeconds || 0;
  }

  _errorMessage(response) {
    switch (response.status) {
    case 412:
      return "Recording not yet available, try again in a few minutes.";
    case 404:
      return "Sorry, recording is unavailable.";
    default:
      return Ajax.parseResponse(response).message;
    }
  }
}
